module.exports = __webpack_public_path__ + "img/34-config-modelos-doc-wizard-info.4a7e8277.png";